import gameIds from 'a/hub/data/GameIds';
import { getAssetFromCache } from 'root/lib/AssetLoader.new';

export const GAME_ID = gameIds.CURIOSO_CROSSING;

export const ROUND_COUNT = 2; // The total number of rounds in a given level

// Gameplay
export const LIVES = 3; // Number of failures allowed before being prompted to Try Again

// Stage
export const STAGE_WIDTH = 1024; // Total Stage Width
export const STAGE_HEIGHT = 576; // Total Stage Height
export const BACKGROUND_WIDTH = 2048; // The total width of a given background piece

// The tiling width of this level's FG content
export const WIDTH_FG = {
  LEVEL1: 2048,
  LEVEL2: 3072,
  LEVEL3: 1200,
  LEVEL4: 2500,
  LEVEL5: 1200,
};

// Enumerates the possible world values
export const WORLDS = {
  LEVEL_1: 'level1',
  LEVEL_2: 'level2',
  LEVEL_3: 'level3',
  LEVEL_4: 'level4',
  LEVEL_5: 'level5',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

// Redux Actions
export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SET_LEVEL: 'SET_LEVEL',
  SET_QUESTION: 'SET_QUESTION',
  MODIFY_LIVES: 'MODIFY_LIVES',
  SET_QUESTION_RESULT: 'SET_QUESTION_RESULT',
  SET_ONBOARDING: 'SET_ONBOARDING',
  INCREMENT_CURRENT_ROUND: 'INCREMENT_CURRENT_ROUND',
};

// Curioso Animation States
export const CURIOSO_ANIMATIONS = {
  IDLE: 'IDLE', // Default state
  QUESTION_RIGHT: 'QUESTION_RIGHT', // Not really used, but could be.
  QUESTION_WRONG: 'QUESTION_WRONG', // Called after a bad answer or automaticity timeout
  WIN: 'WIN', // Level won
  LOSE: 'LOSE', // Level lost
};

// Current game type, used for reporting
export const GAME_TYPE = {
  ONBOARDING: 'onboarding',
  STANDARD: 'standard',
};

// What word type the current question is.
// We always need to have one of these, matches up with
// onboarding too.
export const WORD_TYPE = {
  WORD_VC: 'word_vc', // VC/CVC/CCVC/CVCC word levels
  WORD_COMBINATIONS: 'word_combinations', // Combination levels
  WORD_INFLECTED: 'word_inflected', // Inflected levels
  WORD_PREFIX: 'word_prefix', // Prefixes and Suffixes
  WORD_TWO_SYLLABLE: 'word_two_syllable', // Two Syllable
  WORD_MULTI_SYLLABLE: 'word_multi_syllable', // Multi-syllable
  AUTOMATICITY: 'automaticity', // Automaticity
};

export const getTransformValue = ({ x, y }) => `translateX(${x}px) translateY(${y}px)`;

export const getPiecesByLevelData = (level, levelAssetKeys, stylesByAsset) => levelAssetKeys.map((levelAsset) =>
  ({
    key: levelAsset,
    Component: getAssetFromCache(level[levelAsset]),
    styles: stylesByAsset[levelAsset],
  }),
);

// milliseconds before Automaticity timeout
export const AUTOMATICITY_SPEEDS = {
  DEFAULT: 35000,
  MEDIUM: 22500,
  FAST: 17500,
};

// Current game instruction state
export const INSTRUCTION_STATE = {
  UNPLAYED: 'unplayed',
  PLAYING: 'playing',
  PLAYED: 'played',
};

// Current game onboarding state
export const ONBOARD_STATE = {
  NONE: 'none',
  INSTRUCTION: 'instruction',
  HI_TARGET_1: 'hi_target_1',
  HI_TARGET_2: 'hi_target_2',
  HI_TARGET_3: 'hi_target_3',
  HI_DISTRACTOR_1: 'hi_distractor_1',
  HI_DISTRACTOR_2: 'hi_distractor_2',
  HI_DISTRACTOR_3: 'hi_distractor_3',
  ENTRY: 'entry',
};

export const TARGET_UNDERLINE_INDEX_DATA = {
  [ONBOARD_STATE.HI_TARGET_1]: 0,
  [ONBOARD_STATE.HI_TARGET_2]: 1,
  [ONBOARD_STATE.HI_TARGET_3]: 2,
};

export const DISTRACTOR_UNDERLINE_INDEX_DATA = {
  [ONBOARD_STATE.HI_DISTRACTOR_1]: 0,
  [ONBOARD_STATE.HI_DISTRACTOR_2]: 1,
  [ONBOARD_STATE.HI_DISTRACTOR_3]: 2,
};

export const TARGET_ONBOARD_STATES = [
  ONBOARD_STATE.HI_TARGET_1,
  ONBOARD_STATE.HI_TARGET_2,
  ONBOARD_STATE.HI_TARGET_3,
];

export const DISTRACTOR_ONBOARD_STATES = [
  ONBOARD_STATE.HI_DISTRACTOR_1,
  ONBOARD_STATE.HI_DISTRACTOR_2,
  ONBOARD_STATE.HI_DISTRACTOR_3,
];

export const STREAK_REACTION_KEYS = {
  STREAK1: 'streak1',
  STREAK2: 'streak2',
  STREAK3: 'streak3',
};

export const SCROLL_MULTIPLIER = -1; // Negative for opposing scroll direction
export const SCROLL_PAN_RATE = 0.75; // Rate at which the "camera" pans, in seconds
export const SCROLL_PAN_DELAY = 0.3; // Delay before the camera starts panning
export const SCROLL_RATE = 1.2;
export const SCROLL_PAN_OFFSET = -350; // Scroll camera offset
export const LAYERS_TIMELINE_ID = 'layersLoopId';
export const CURIOSO_IDLE_LOOP_COUNT_BEFORE_STRETCH = 3; // How many times to play the normal idle before the stretch animation of curioso
export const JUMP_TIME_IN_SECONDS = 0.6; // Total time of the jump idle animation
export const JUMP_Y_OFFSET = -25; // Amount to jump into the air before jumping down
export const PLATFORM_Y_POSITION = 50; // Y position for the character
export const FADE_DURATION_IN_MS = 200;
export const FALLING_REACTION_DELAY = 1500;
export const SUCCESS_REACTION_DELAY = 700;
export const AUTOMATICITY_OFFSET = -50; // Final automaticity offset
export const INSTRUCTION_BACK_PAUSE = 500;
